var root=require("./_root"),Uint8Array=root.Uint8Array;module.exports=Uint8Array;